import { getCmsRoutes } from "../../../app/api/getCmsRoutes";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse } from "../../../Orchestrator/Types/Index";
import { ICmsRoute, ICmsRoutesResponse } from "../../../Orchestrator/Types/Interface/ICmsRoutes";

class GetCmsRoutesAction extends BaseAction<ICmsRoute[], void> {
  override async run(): Promise<ICmsRoute[] | null> {
    let listOfRoutes: ICmsRoute[] = [];
    try {
      const response: IApiResponse<ICmsRoutesResponse> = await getCmsRoutes();

      if (response.status === "ok" && response.answer) {
        const routes = response.answer.data;
        if (routes.length > 0) {
          listOfRoutes = routes
          updateRecoilState("routesResponseAtom", listOfRoutes);
        } else {
          console.warn("No routes available.");
        }
      } else {
        console.warn("Failed to fetch routes.");
      }
    } catch (error: any) {
      console.error("Error fetching routes:", error);
    } finally {
      updateRecoilState("routesLoadedAtom", true);
      return listOfRoutes;
    }
  }
}

export const getCmsRoutesAction = new GetCmsRoutesAction()
